module.exports = __webpack_public_path__ + "img/wya_stamp_new.e08a370d.png";